import { createStore, applyMiddleware, combineReducers } from 'redux';
import { HYDRATE, createWrapper } from 'next-redux-wrapper';
import createSagaMiddleware from 'redux-saga';
import thunkMiddleware from 'redux-thunk';
import count from '@/store/redux/reducer';
import rootSaga from '@/store/redux/saga';
// import tick from './tick/reducer';

const bindMiddleware = middleware => {
  if (process.env.NODE_ENV !== 'production') {
    const { composeWithDevTools } = require('redux-devtools-extension');
    return composeWithDevTools(applyMiddleware(...middleware));
  }
  return applyMiddleware(...middleware);
};

const combinedReducer = combineReducers({
  count,
  // tick,
});

const reducer = (state, action) => {
  return combinedReducer(state, action);
  // if (action.type === HYDRATE) {
  //   const nextState = {
  //     ...state, // use previous state
  //     ...action.payload, // apply delta from hydration
  //   };
  //   if (state.count) nextState.count = state.count; // preserve count value on client side navigation
  //   return nextState;
  // } else {
  //   return combinedReducer(state, action);
  // }
};

const initStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(
    reducer,
    bindMiddleware([sagaMiddleware, thunkMiddleware]),
  );

  store.sagaTask = sagaMiddleware.run(rootSaga);

  return store;
  // return createStore(reducer, bindMiddleware([thunkMiddleware]));
};

export const wrapper = createWrapper(initStore);
